import { useMemo } from "react";

import type { CostCenters } from "@/apis/gql/types";

import { AutocompleteInput, type Option } from "./autocomplete-input";

type Props = {
  name: string;
  placeholder: string;
  label?: string;
  options: CostCenters[];
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  side?: "top" | "right" | "bottom" | "left";
  sideOffset?: number;
  autoFocus?: boolean;
  showEmptyLabel?: boolean;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onFocus?: (value: Option["value"]) => void;
};

export const CostCenterAutocompleteInput = ({
  name,
  placeholder,
  sideOffset,
  side,
  label,
  options: _options,
  onBlur,
  onFocus,
  onKeyDown,
  autoFocus,
  showEmptyLabel,
}: Props) => {
  const options = useMemo(() => {
    return (
      _options?.map((costCenter) => ({
        value: costCenter.costCenterId,
        label: costCenter.name,
        subLabel: costCenter.identifier,
      })) ?? []
    );
  }, [_options]);

  const filterBy = (
    inputValue: string,
    value: Option["value"],
    label: Option["label"],
    subLabel: Option["subLabel"],
  ) => {
    const _search = inputValue.replace(/ /g, "");
    const _label = label.replace(/ /g, "");
    const _subLabel = subLabel?.replace(/ /g, "") ?? "";

    return (
      _label.toLowerCase().includes(_search.toLowerCase()) ||
      _subLabel.toLowerCase().includes(_search.toLowerCase())
    );
  };

  return (
    <AutocompleteInput
      name={name}
      label={label}
      placeholder={placeholder}
      options={options}
      onKeyDown={onKeyDown}
      sideOffset={sideOffset}
      side={side}
      filterBy={filterBy}
      autoFocus={autoFocus}
      onBlur={onBlur}
      onFocus={onFocus}
      showEmptyLabel={showEmptyLabel}
    />
  );
};
